import { auth, db, storage } from '@/firebase/init';

import { doc, setDoc, getDoc } from "firebase/firestore"; 

import { getUserMail, getUserName } from "@/firebase/sesion";

const admin = new Set();

// Only one admin user as specified
admin.add("6KAyZ5CrB3cNJzQdbrgRIUy57EV2");

export class User {
    constructor(uuid, update = true, name = "", mail = "", favorites = [], type = 0) {
        User.uuid = uuid;
        if (name === "") {
            getDoc(doc(db, "users", User.uuid)).then((d) => {
                if (d.exists()) {
                    console.log('User already exists');
                    User.uuid = d.data().uuid;
                    User.nom = d.data().nom;
                    User.mail = d.data().mail;
                    User.favorites = d.data().favorites;
                }else{
                    User.nom = getUserName();
                    User.mail = getUserMail();
                    User.favorites = [];
                    User.update();
                }
            })
        } else {
            User.nom = name;
            User.mail = getUserMail();
            User.favorites = [];
            User.update();
        }
    }

    static isFav(uuid){
        return User.favorites.includes(uuid);
    }

    static getFav(){
        return User.favorites;
    }

    static clearFavorites(){
        User.favorites = [];
        User.update();
    }

 
    static async getUser(uuid){
        User.uuid = uuid;
        const userRef = doc(db, "users", uuid);
        const d = await getDoc(userRef);
        
        if (d.exists()) {
            // User exists, load their data
            User.uuid = d.data().uuid;
            User.nom = d.data().nom;
            User.mail = d.data().mail;
            User.favorites = d.data().favorites || [];
            console.log('User loaded:', User.mail);
        } else {
            // User doesn't exist, create them
            console.log('User not found in Firestore, creating new user document');
            const currentUser = auth.currentUser;
            if (currentUser) {
                User.uuid = uuid;
                User.nom = currentUser.displayName || '';
                User.mail = currentUser.email || '';
                User.favorites = [];
                
                // Save to Firestore
                await setDoc(userRef, {
                    uuid: User.uuid,
                    nom: User.nom,
                    mail: User.mail,
                    favorites: User.favorites,
                    createdAt: Date.now()
                });
                console.log('New user created in Firestore:', User.mail);
            }
        }
    }

    static async addFav(productUUID) {
        User.favorites.push(productUUID);
        return setDoc(doc(db, "users", User.uuid), {
            uuid: User.uuid,
            nom: User.nom,
            mail: User.mail,
            favorites: User.favorites
        });
    }

    static async removeFav(productUUID) {
        User.favorites = User.favorites.filter((uuid) => uuid !== productUUID);
        return setDoc(doc(db, "users", User.uuid), {
            uuid: User.uuid,
            nom: User.nom,
            mail: User.mail,
            favorites: User.favorites
        })
    }

    static hasUser(){
        return User.uuid !== "";
    }

    static async update(){
        return setDoc(doc(db, "users", User.uuid), {
            uuid: User.uuid,
            nom: User.nom,
            mail: User.mail,
            favorites: User.favorites,
        });
    }

    static isAdmin(){
        return admin.has(User.uuid);
    }

    static async isAdminAsync() {
        // Check hardcoded list first
        if (admin.has(User.uuid)) return true;
        
        // Check Firestore admin list
        try {
            const adminRef = doc(db, 'admin', 'admins');
            const snap = await getDoc(adminRef);
            if (snap.exists()) {
                const data = snap.data();
                const adminUids = new Set(data.uids || []);
                return adminUids.has(User.uuid);
            }
        } catch (e) {
            console.error('Error checking admin status:', e);
        }
        return false;
    }

    
}

// Initialize static properties
User.uuid = "";
User.nom = "";
User.mail = "";
User.favorites = [];
